import { APPOINTMENT_REMINDER_MODES, DEFAULT_APPOINTMENT_REMINDER_MODE, DEFAULT_FOLLOWUP_DELAY_HOURS, FOLLOWUP_DELAY_HOURS_OPTIONS, REMINDER_OFFSETS_BY_PACKAGE, REMINDER_OFFSET_HOURS_OPTIONS, } from './catalog';
export function resolveAppointmentReminderPolicy(raw, packageType) {
    if (typeof raw !== 'object' || raw === null || Array.isArray(raw))
        return null;
    const obj = raw;
    if (obj.enabled !== true)
        return null;
    const rawOffsets = Array.isArray(obj.reminderOffsetsHours) ? obj.reminderOffsetsHours : null;
    const filtered = rawOffsets === null
        ? null
        : rawOffsets.filter((o) => REMINDER_OFFSET_HOURS_OPTIONS.includes(o));
    // Array explícito (mesmo parcial) prevalece; ausente/malformado/vazio cai no
    // default do pacote (enabled sem offsets nunca significa "zero lembretes" —
    // para desligar, `enabled: false`).
    const offsets = filtered !== null && filtered.length > 0 ? filtered : REMINDER_OFFSETS_BY_PACKAGE[packageType];
    const reminderOffsetsHours = [...new Set(offsets)].sort((a, b) => b - a);
    const followupEnabled = obj.followupEnabled === true;
    const followupDelayHours = FOLLOWUP_DELAY_HOURS_OPTIONS.includes(obj.followupDelayHours)
        ? obj.followupDelayHours
        : DEFAULT_FOLLOWUP_DELAY_HOURS;
    const mode = APPOINTMENT_REMINDER_MODES.includes(obj.mode)
        ? obj.mode
        : DEFAULT_APPOINTMENT_REMINDER_MODE;
    return { reminderOffsetsHours, followupEnabled, followupDelayHours, mode };
}
//# sourceMappingURL=resolve.js.map